export function init() {}

export function log(error) {
  console.log('logging the error', error);
}
